import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EmployeeService } from "src/app/services/employee.service";
import { Organization, ServiceRequestResponseTypes, UserClient,UserModel,UserProfession,UserProfessionClient,UserProfile,UserRoleTypes, WorkingGroupClient, WorkingGroups } from "src/app/web-api-client";
import { NomenclatrueService } from "../../../services/nomenclature.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject, forkJoin } from "rxjs";
import { WtStorageService } from "../../../wt-storage.service";
import { ServiceRequestResponseTypeUtil } from "../../../shared/utils/service-request-response.utils";

@Component({
  selector: 'app-user-creation',
  templateUrl: './user-creation.component.html',
  styleUrls: ['./user-creation.component.scss']
})
export class UserCreationComponent implements OnInit  {

  public onClose = new Subject<boolean>();
  public isLoaded = false;
  public organizations: Organization[];
  public workingGroups: WorkingGroups[] = [];
  public userProfessions: UserProfession[] = [];
  public UserRoleTypes = UserRoleTypes;
  public roleTypes = Object.keys(UserRoleTypes).filter(
    key => !isNaN(Number(UserRoleTypes[key]))
  );
  public currentUser: UserProfile;
  userForm: FormGroup;

  public responseTypes = Object.keys(ServiceRequestResponseTypes)
    .filter(key => !isNaN(Number(ServiceRequestResponseTypes[key])))
    .map(key => ({ name: key, value: ServiceRequestResponseTypes[key] }));


  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,public localStore:WtStorageService, public userClient: UserClient, public employeeService: EmployeeService, public nomenclatureService: NomenclatrueService
    , public workingGroupClient: WorkingGroupClient, public userProfessionClient: UserProfessionClient) { }

  ngOnInit(): void {

    forkJoin([this.nomenclatureService.getOrganizations(), this.workingGroupClient.getList(), this.userProfessionClient.getList()]).subscribe(([orgs, workingGroups, userProfessions])=>{

      this.workingGroups = workingGroups;
      this.userProfessions = userProfessions;
      this.organizations = orgs;
      this.initializeForm();
      this.currentUser = this.localStore.getuser();

      //Check if it is global org
      if (this.currentUser.organization.organizationalType !== 0) {
        this.roleTypes = this.roleTypes.filter(d => UserRoleTypes[d] != UserRoleTypes.Global_Admin)
      }

      this.isLoaded = true;

    });


  }

  initializeForm() {
    this.userForm = this.fb.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      username: ['', Validators.required],
      organization: ['', Validators.required],
      workingGroup: [''],
      userProfession: [0],
      egn: ['', Validators.required],
      isService: [false, Validators.required],
      role: [null, Validators.required],
      responseType: [0]
    });
  }

  onSubmit() {
    if (this.userForm.valid) {

      let newUser =new UserModel();

      newUser.id = 0,
        newUser.organization = '',
        newUser.firstName = this.userForm.value.name,
        newUser.lastName = this.userForm.value.surname,
        newUser.role = this.userForm.value.role,
        newUser.organizationId = this.userForm.value.organization,
        newUser.idWorkingGroup = this.userForm.value.workingGroup,
        newUser.email = this.userForm.value.username,
        newUser.egn = this.userForm.value.egn;
        newUser.isService = this.userForm.value.isService;
        newUser.userProfessionIdUserProfession = this.userForm.value.userProfession;
        newUser.notificationType = +this.userForm.value.responseType;
      this.userClient.createUser(newUser).subscribe((user) => {
        this.onClose.next(true);
this.activeModal.close();
      });
    }
  }

  public GetCyrilicRequestType(requestType: ServiceRequestResponseTypes): string {

    return ServiceRequestResponseTypeUtil.getCyrilicLabel(requestType);
  }

}
